import { Facebook, ExternalLink } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="page-footer"
      className="border-t px-5 pt-16 pb-10 sm:px-8"
      style={{ borderColor: "var(--border-delicate)", backgroundColor: "var(--bg-surface)" }}
    >
      <div className="mx-auto max-w-7xl">
        <p
          className="font-cinzel select-none text-center text-[11vw] leading-none tracking-[0.12em] lg:text-[7rem]"
          style={{ color: "var(--text-primary)", opacity: 0.12 }}
        >
          MAA PREM MAHIMA
        </p>

        <p className="font-display mx-auto mt-10 max-w-xl text-center text-xl italic sm:text-2xl" style={{ color: "var(--text-secondary)" }}>
          {t("footer.quote")}
        </p>

        <div className="mt-12 flex flex-col items-center justify-between gap-6 border-t pt-8 sm:flex-row" style={{ borderColor: "var(--border-delicate)" }}>
          <p className="font-mono-alt text-[11px] uppercase tracking-[0.25em]" style={{ color: "var(--text-muted)" }}>
            © {new Date().getFullYear()} Maa Prem Mahima · Osho Universal
          </p>
          <div className="flex items-center gap-6">
            <a
              data-testid="footer-oshouniversal-link"
              href="https://oshouniversal.org/co-founder-mahima"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs tracking-wide transition-colors"
              style={{ color: "var(--text-secondary)" }}
            >
              <ExternalLink size={13} /> Osho Universal
            </a>
            <a
              data-testid="footer-facebook-link"
              href="https://www.facebook.com/profile.php?id=61583757579796"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs tracking-wide transition-colors"
              style={{ color: "var(--text-secondary)" }}
            >
              <Facebook size={13} /> Facebook
            </a>
            <a
              data-testid="footer-admin-link"
              href="/admin"
              className="text-xs tracking-wide transition-colors"
              style={{ color: "var(--text-muted)" }}
            >
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
